export const MU_NAME_TO_BASE_NUM_REGEXP = /ВОЙСК.*\s+ЧАСТ.*\s+№?(\d{4,5}[\s{1}-][а-яА-Я]$|\d{4,5}[\s{1}-]\d+|\d{4,5})/

export const WIKIMAPIA_APIKEY = 'WIKIMAPIA_APIKEY'
export const WIKIMAPIA_LOGIN = 'WIKIMAPIA_LOGIN'
export const WIKIMAPIA_PASSWORD = 'WIKIMAPIA_PASSWORD'
